var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current_incident)?_c('q-card',{class:_vm.$q.screen.gt.xs ? 'q-ma-xl' : 'q-ma-sm'},[_c('Incident',{attrs:{"incident":_vm.current_incident}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }